const dictionary = {
  paperVaraint: "outlined",
  logOutColor: "error",
  titleVariant: "h1",
};
export default dictionary;
